"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const plurals = [
    'all',
    'convoy',
    'everyone',
    'everybody',
    'people',
    'crowd',
    'mob',
    'angry mob',
    'party',
    'partygoers',
    'partiers',
    'audience',
    'citizens',
    'townspeople',
    'voters',
    'clients',
    'class',
    'group',
    'groups',
    'friends',
    'pals',
    'kids',
    'witches',
    'patrons',
    'mass',
    'masses',
    'ensemble',
    'players',
    'team',
    'band',
    'whole band',
    'entire band',
    'bands',
    'crew',
    'gang',
    'gangs',
    'troops',
    'droves',
    'swarm',
    'swarms',
    'hosts',
    'gathering',
    'throng',
    'assembly',
    'multitude',
    'horde',
    'hoard',
    'pack',
    'packs',
    'bunch',
    'flock',
    'huddle',
    'whole',
    'every',
    'caucus',
    'conclave',
    'congregation',
    'faction',
    'convocation',
    'multitude',
    'spectators',
    'witnesses',
    'observers',
    'public',
    'publics',
    'admirers',
    'devotees',
    'fans',
    'gallery',
    'peanut gallery',
    'patrons',
    'theatergoers',
    'viewers',
    'showgoers',
    'playgoers',
    'listeners',
    'devotees',
    'bevy',
    'cluster',
    'company',
    'troupe',
    'corps',
    'clique',
    'coterie',
    'club',
    'clubs',
    'covey',
    'coveys',
    'cluster',
    'numbers',
    'order',
    'society',
    'creed',
    'tribe',
    'tribes',
    'selection',
    'selections',
    'medley',
    'omnibus',
    'partners',
    'syndicates',
    'community',
    'league',
    'leagues',
    'clan',
    'clans',
    'assortment',
    'corporation',
    'council',
    'cabinet',
    'ministry',
    'chamber',
    'parliament',
    'panel',
    'judges',
    'board',
    'chorus',
    'choir',
    'orchestra',
    'organization',
    'cast',
    'trio',
    'duo',
    'drove',
    'colony',
    'herd',
    'scores',
    'brood',
    'army',
    'riot',
    'conference',
    'congress',
    'division',
    'symposium',
    'bunch',
    'cartel',
    'league',
    'posse',
    'trust',
    'platoon',
    'grade',
    'association',
    'school',
    'gaggle',
    'assemblage',
    'host',
    'hosts',
    'anchors',
    'festival',
    'festival goers',
    'rally',
    'shindig',
    'hoopla',
    'alliance',
    'coalition',
    'lot',
    'collection',
    'ring',
    'scad',
    'senate',
    'court',
    'guests',
    'orgy',
    'soiree',
    'gala',
    'attendees',
    'outfit',
    'squad',
    'unit',
    'diners',
    'rabble',
    'rank and file',
    'hoi polloi',
    'commoners',
    'reception',
    'roundup',
    'salon',
    'concourse',
    'some',
    'congeries',
    'personnel',
    'force',
    'forces',
    'military',
    'legion',
    'turnout',
    'generic',
    'caravan',
    'colony',
    'shrewdness',
    'cete',
    'shoal',
    'cloud',
    'cauldron',
    'sleuth',
    'litter',
    'swarm',
    'sounder',
    'gang',
    'obstinancy',
    'clowder',
    'glaring',
    'pounce',
    'herd',
    'drove',
    'coalition',
    'brood',
    'peep',
    'clutch',
    'chattering',
    'quiver',
    'fold',
    'flink',
    'sedge',
    'float',
    'bask',
    'murder',
    'pack ',
    'cowardice',
    'pod',
    'dule',
    'paddling',
    'team',
    'brace',
    'convocation',
    'parade',
    'mob',
    'cast',
    'business',
    'fesnyng',
    'charm',
    'school',
    'shoal',
    'run',
    'haul',
    'catch',
    'stand',
    'flanboyance',
    'swarm',
    'hatch ',
    'skulk',
    'leash',
    'gaggle',
    'skein',
    'army ',
    'colony',
    'tower',
    'tribe',
    'trip',
    'troubling',
    'leach',
    'cast ',
    'kettle',
    'bloat',
    'thunder',
    'drift',
    'parcel',
    'harras',
    'mute',
    'cackle',
    'shadow',
    'smack',
    'brood',
    'ascension',
    'exaltation',
    'conspiracy',
    'leap',
    'pride',
    'plague',
    'tiding',
    'tittering',
    'sord',
    'aggregation',
    'stud',
    'richness',
    'steam',
    'labor',
    'barrel ',
    'cartload',
    'watch',
    'barren ',
    'span',
    'family',
    'romp',
    'raft',
    'parliament',
    'bed',
    'pandemonium',
    'company',
    'covey',
    'muster',
    'ostentation',
    'string',
    'prickle',
    'warren',
    'gaze',
    'rhumba',
    'mischief',
    'shiver',
    'unkindness',
    'crash',
    'stench',
    'nest',
    'knot',
    'dray',
    'scurry',
    'murmuration',
    'fever',
    'musteriing',
    'bevy',
    'lamentation',
    'wedge',
    'ambush',
    'streak',
    'hover',
    'rafter',
    'venue',
    'pledge',
    'pledges',
    'route',
    'wisdom',
    'decent',
    'zeal'
];
exports.default = plurals;
